import { Copy, Link, Square, Squish } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { copyVariants } from 'src/utilities/shared-types';
import { RouterLink } from 'src/components/RouterLink/RouterLink';

export interface IMenuItemProps {
  text: string;
  href: string;
  useRouterLink?: boolean;
  copyVariant?: copyVariants;
  copyColor?: string;
  hide?: boolean;
}

export function MenuSubItem({
  text,
  href,
  copyVariant = 'body',
  copyColor = 'primaryText',
  hide,
  useRouterLink,
}: IMenuItemProps): JSX.Element {
  if (hide) {
    return null;
  }

  if (useRouterLink) {
    return (
      <RouterLink href={href}>
        <MenuSubItemElement
          text={text}
          copyVariant={copyVariant}
          copyColor={copyColor}
        />
      </RouterLink>
    );
  }

  return (
    <Link href={href}>
      <MenuSubItemElement
        text={text}
        copyVariant={copyVariant}
        copyColor={copyColor}
      />
    </Link>
  );
}

function MenuSubItemElement({
  text,
  copyVariant,
  copyColor,
}: Partial<IMenuItemProps>): JSX.Element {
  return (
    <Squish
      className="subItem"
      inset="sm"
      bg="globals.white"
      borderBottomStyle="solid"
      borderBottomColor="lightLine"
      borderBottomWidth={1}
    >
      <Square padding="8px">
        <Copy variant={copyVariant} color={copyColor}>
          {text}
        </Copy>
      </Square>
    </Squish>
  );
}
